<ion-header>
  <ion-toolbar [color]="color">
    <ion-title>{{titulo}}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="modalCtrl.dismiss()">
        <ion-icon slot="icon-only" name="close-circle"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
  <quill-view [content]="texto"></quill-view>
</ion-content>
